import { PipelineDebug } from '~/app/components/pipeline-debug/PipelineDebug/PipelineDebug';
import type { PipelineDebugPageViewProps } from './PipelineDebugPage.types';

export function PipelineDebugPageView({
  isSuperAdmin,
  organizationId,
  organizations,
  onOrganizationIdChange,
  assetId,
  assets,
  onAssetIdChange,
  isLoadingAssets,
}: PipelineDebugPageViewProps) {
  return (
    <PipelineDebug
      isSuperAdmin={isSuperAdmin}
      organizationId={organizationId}
      organizations={organizations.map((organization) => ({
        id: organization.id,
        name: organization.name,
      }))}
      onOrganizationIdChange={onOrganizationIdChange}
      assetId={assetId}
      assets={assets}
      onAssetIdChange={onAssetIdChange}
      isLoadingAssets={isLoadingAssets}
    />
  );
}
